
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's03c44f5a1b0581d4': `sélectionné`,
's03c75db6e18f29d2': `connexion`,
's03f42eea72154959': `Nom d'utilisateur`,
's053eb89714fe5c46': `Puissance`,
's05e136e67bf479ad': `mètres`,
's0654bb31ab7b7181': `Propriétés sélectionnées`,
's080f5119176d1ff9': `max`,
's091d5d07b5b33dcf': `OK`,
's09b7ae18afb52426': `Profil lumineux`,
's0a95ea7c8e330485': `Latitude`,
's0b43e6e909895c89': `Horizontal`,
's0bd108911963a54f': `Froide`,
's0d1be7a2c400c080': `Plus`,
's0d249b4af3381730': `Veuillez vous connecter`,
's0ddc950e757e1973': `Fiche technique standard`,
's0ed0176ae4af6fd2': `Schéma annuel`,
's0eeef467da6b181a': `L'emplacement est déterminant pour la configuration. Chaque site présente des caractéristiques
					spécifiques.
				`,
's0fbf6dc6a1966408': `Suivant`,
's101f0e6c075f0306': `Conseils personnalisés`,
's11354e32ca275229': `Point lumineux`,
's125083191daf6f61': `Faible`,
's15a852e9f9a50fa5': `Juin`,
's15b92ca12f290f37': `24h Profil de gradation`,
's1667f96d19635ec7': `Zone`,
's16b9446e3a70e1f4': `Caractéristiques`,
's16beb7f7aca65d4a': `Votre configuration d'éclairage est prête à être téléchargée.`,
's180f872a88570719': `Accessoires`,
's18f78df8a253a3bd': `Modifier cette configuration`,
's1c9fc46adbc800fc': `Nous n'avons pas trouvé le lieu.`,
's1da50951bdd7a204': `Canal`,
's1e49e107896ce7fe': `La première étape est terminée.`,
's1eb320f7fc4c79d3': `olivio_start_titre`,
's2122b8c621efd5fe': `Texte d'appel d'offres`,
's2138d5192571b731': `nouveau`,
's21900f027f2d7cfa': `Diamètre`,
's22a8350054d8a2f3': `cable de raccordement`,
's23685a920290045d': `Luminaire`,
's25858219b90108cb': `LDT`,
's25f6e9b435aa1079': `boitier fusible`,
's2652c22671dc46da': `Copier cette configuration`,
's26d236d09a66a620': `Règles`,
's26f5f8b809fd7fe5': `Télécharger l'image du produit (png)`,
's27c10d6b0a1f1eb1': `sur demande`,
's28414724644bccc4': `Exemple de journées`,
's28e1da9966f65d52': `Hauteurs de points lumineux disponibles`,
's295b16cb2e4eeaa7': `En savoir plus sur`,
's2cb4ef8646d0e517': `Instructions de montage`,
's2ceb11be2290bb1b': `Annuler`,
's2deee7c162e1558b': `déconnexion`,
's2ee707397f19f23d': `Profil de l'année complète (max)`,
's2fba71bd651bdbfb': `Vertical`,
's302c01e9021c7d0a': `Jour de référence: hiver 21.12, été 21.06, printemps/automne: 21.09`,
's30c5118924e9ccf7': `Instructions de montage`,
's32608f5f2b7f01ff': `Attributs insatisfaits`,
's351c13d86108cce3': `Luminaire`,
's36a54400db774fd6': `Emplacement hors de portée`,
's37643c19c348229c': `Numéro`,
's3800b4d177951a38': `angle de la porte du mât`,
's38cb83ea5c1270b3': `Distribution lumineuse`,
's3b0ab4b52326316f': `Lumière`,
's3c04f27ce20ea918': `Hauteur totale`,
's3d4a07895c83def3': `Ces paramètres seront appliqués à tous les luminaires.`,
's3fda2cc80886276c': `mètre`,
's4394ed0a03867f18': `Hauteur du point lumineux`,
's44632e3cdf4265d0': `Facteur de maintenance du flux lumineux`,
's464ff0695f87139f': `Pour ce lieu, veuillez nous contacter afin que nous puissions vous fournir un profil de lumière
					circulaire personnalisé.
				`,
's478248ace1f398b0': `Luminaires`,
's47ebf3a8fb3b10c1': `Orientation`,
's48344928cb4a4f8d': `Choisir la localisation du projet`,
's48e186fb300e5464': `Heure`,
's4f8c1254653e1188': `dimmé puissance`,
's5048efbcb03a6a20': `Données Techniques`,
's5052d10b539eabf0': `Mars`,
's52d1befc2b7b05b6': `Identifiant de configuration`,
's5390f55090d59178': `Aeto s'adapte de manière flexible aux exigences de l'environnement et du projet. Grâce à notre
					configurateur, déterminez les puissances lumineuses possibles en fonction de la taille de l'unité
					solaire à l'aide des données statistiques sur l'ensoleillement et la météo des dix dernières années
					au moins.
				`,
's53c69c5f21db188f': `Luminaire bas`,
's542a2430b5e7bf68': `Le rayonnement solaire est calculé sans ombrage et avec une orientation au nord.`,
's5548520a6d89e647': `Autres propriétés disponibles`,
's56a0dcacefc0078c': `LDT Fichiers`,
's56f9bc194465a83c': `en haut`,
's59b52ef0a2362cf4': `Profil d'éclairage`,
's5bb297d85a6de998': `Angle`,
's5ca9a41556de2c52': `porte de mât`,
's5dd028a12ddb124b': `Votre profil lumineux`,
's5e399df62bea2918': `Chaude`,
's61053f0e3ebbd272': `Normale`,
's6387848b18b50c80': `Fiche technique détaillée`,
's63cc891eb48fbf58': `Votre luminaire`,
's669b18c6d2d9c95b': `sans`,
's66c5b77248cfa1af': `Donnés Luminaire`,
's67e5c254c4d8832d': `Contactez-nous pour plus d'informations`,
's682df6874fed3750': `Vue du tableau`,
's6a5a1ac0f1a00bc5': `composé de`,
's6b61044deda3df65': `L'action souhaitée n'est pas possible avec vos décisions précédentes. Voulez-vous désactiver ces
					choix pour continuer?
				`,
's6b7d7afabc24ff1c': `Propriétés`,
's6e254074fbee8e0d': `dimmé`,
's6ec56fb545de4b76': `N'hésitez pas à prendre contact avec nous pour échanger et pour de plus amples informations.
				`,
's6fd32ab00cd5b6fd': `Luminaire haut`,
's7360eecc9b38343d': `Elevée`,
's740de1b7b1a14f0c': `Flux lumineux`,
's7574e7a84b0fb574': `Été`,
's75ed09a809d91f7b': `Package`,
's76bab8c674e485c3': `Spécifications`,
's7878f63fba88920a': `Jour de référence: été 21.12, hiver 21.06, printemps/automne: 21.09`,
's794a2ed0326f8bd3': `Distribution lumineuse`,
's7965f9dc5548469e': `Votre zone:`,
's79a9ea7671b44bdc': `Configurez pour votre projet le nouveau luminaire solaire efficace Aeto.`,
's7e87a6b2c1d7bc13': `Console`,
's7ebe6e1acc5d757a': `Etroite`,
's8031a80d73f6ebe0': `nombre`,
's80629ca60d4d77eb': `Découvrir le profil d'éclairage en détail`,
's84e4ad9f3933d98d': `Pour accéder aux options de configuration étendues, veuillez`,
's863b04cd4fb72226': `Capacité de la batterie`,
's8677332490c997b4': `Images projets`,
's874b4e33320ea9fa': `LDT`,
's8750ed2a956654c9': `Fiche technique`,
's87d32bdbee7f327f': `Votre profil de lumière:`,
's89e9be1960f4c21c': `rouge`,
's8a957ce1c55ba8f0': `Connecté:`,
's8c0df50fb122616e': `Longueur de focale`,
's8d5cb019f3cae535': `PDF`,
's8d802fff3bde98c3': `Démarrer une nouvelle configuration`,
's904478720bf69a20': `Copier le texte pour appel d'offres`,
's923a14357bb70193': `Automne`,
's97de9a19fa44513a': `UGS`,
's9822e5e8ef283182': `Intensité lumineuse`,
's9844ab19fa9b214f': `Sep`,
's9a6e47771188568d': `Ombrage`,
's9ae3ff84f2b87d2b': `Télécharger PDF`,
's9bf7d6fdcd9de5ce': `C'est de cette réflexion qu'est née l'idée d'adapter la lumière artificielle aux rythmes
					naturels : un peu différente chaque jour, à chaque saison et dans chaque endroit du monde, mais
					toujours unique.
				`,
's9d8b8aa2b404c2c8': `Paramètres`,
's9e68097114e9bc2e': `Configuration détaillée des profils lumineux`,
's9eba0933010df96e': `Plus d'informations`,
's9f0c705e2fd7e391': `Commencez la configuration`,
's9f6131367f5a6a54': `dimmé flux lumineux total`,
's9f6adc16f5202086': `Images produit`,
's9f6bf30ed0f3ca9f': `Mesures de perçage`,
'sa0705f8fa177fccd': `incl.`,
'sa1070ff7d8c004c4': `Heure de la journée`,
'sa12222c2106905a6': `Un ou plusieurs luminaires sélectionnés sont édités. La sélection d'une disposition prédéfinie
                    remplace les réglages individuels.
                `,
'sa25de1d82d6a4d4e': `Longitude`,
'sa36aef46efe431eb': `Modèles`,
'sa56481dc40b0fff2': `Fiche technique détaillée`,
'sa875b4fce70c7dcf': `Éclairage pour l’espace urbain. Olivio propose une grande variété de designs et d’options
					d’éclairage, offrant une liberté de création pour des mises en scène spatiales uniques.
				`,
'sa9f14ae61a187f50': `Température de couleur`,
'sab04edd077c7d213': `Les attributs requis suivants sont manquants`,
'sab08f8abe884ba64': `Unité solaire`,
'sab753c5233ef454e': `Description du produit`,
'sac8252732f2edb19': `Date`,
'sb33fc919a70e0e33': `Mât`,
'sb59d68ed12d46377': `chargement`,
'sb6fd9beeccbb8be4': `Sélectionnez les attributs requis pour modifier les niveaux de gradation.`,
'sb77b5dabc9a1321e': `Luminaire sélectionné`,
'sb8c3a89a2602d1c6': `Data Hub`,
'sba56141a5ab71a2a': `Luminaires`,
'sbb99f4f1499715c1': `Nous attendons avec impatience l'avenir de la lumière.`,
'sc033d576e2617aab': `La caractéristique souhaitée n'est pas possible avec vos décisions antérieures.`,
'sc03688bcf16db798': `Choisissez une famille de produits`,
'sc0bd6202ba1e9149': `Profil lumineux circulaire`,
'sc141922a5906fd93': `demande de connexion`,
'sc15d10811c62c5eb': `Numéro article`,
'sc16e00a7a8b2fde2': `Retour`,
'sc1966aa0d7e2d0fe': `Notre recommandation de luminaires`,
'sc1a1ae295cc1f0c3': `Calcul des données photovoltaïques. Veuillez patienter...`,
'sc1a4e2a7a8e20d58': `Base`,
'sc3878186f443a5e8': `Texte d'appel d'offres pour la famille`,
'sc3f22766aede7f77': `olivio_start_description`,
'sc57d00c739a6b90b': `Fiche technique détaillée`,
'sc6c266995fa1f461': `Position verticale`,
'sc76a095e1ffa22b6': `Moyenne`,
'sc8f79f1d775ddfa4': `Configurateur momentanément indisponible`,
'sc9474bf7a0668d73': `Résumé`,
'sc956f29d2ff0ef07': `Emplacement non trouvé`,
'sca51b3d6b0d00e47': `Luminaires disponibles`,
'sca91d01075c0ce84': `Lever du soleil`,
'scb320e45978d3390': `Fabricant`,
'scc75879e9b6998da': `Flux`,
'scd5bf30253fea7aa': `Large`,
'sce10e2a2c48d13c0': `Merci de votre compréhension.`,
'sce2d17cf5d18dee3': `Formulaire de contact`,
'sceb0a248069915e2': `Le configurateur fait actuellement l’objet d’une mise à jour et n’est donc pas accessible pour le moment. Pour toute assistance, veuillez contacter votre interlocuteur Selux.`,
'sd3386a2ef42e80b9': `Télécharger`,
'sd35032a7b73b36ac': `Hiver`,
'sd37ea6e6a94f7a7a': `Paramètres de perçage`,
'sd5d820e378ce757e': `Instructions de montage`,
'sd697d9c07465ce87': `Coucher du soleil`,
'sdac1a66caafe39b2': `Réinitialiser la configuration`,
'sdad2ea94744ca934': `Fiche technique de la famille`,
'sdb4f497ba38af24e': `du haut`,
'sdcb27818fed9da90': `pour`,
'sdce919bbdc89eb6b': `Configure`,
'sde96c07df45da349': `Famille`,
'se08a40f0f6141500': `internes`,
'se1f4fdbaf847ffb1': `Surcharge`,
'se6f09b190519daa4': `tous`,
'se9d2aaa5182ec3fc': `Rendement énergétique`,
'sec2557a35b702525': `Variable`,
'seded372023a9fe71': `Technologie d'éclairage`,
'see2fcaedf9743ec6': `Localisation`,
'seed76e8afe9f604a': `Prix`,
'sf2969ec25d7c997d': `Puissance du système`,
'sf4a1ba82937d9fd3': `Fiche technique standard`,
'sf5bdced3225ede77': `Caractéristiques spéciales`,
'sf6e1665c7022a1f8': `Mot de passe`,
'sfc37108739c69a73': `Fiche technique standard`,
'sfcb319624c989982': `Luminaire sélectionné`,
'sfd1e1dc1bf9acb1b': `Depuis plus de 75 ans, nous nous intéressons à la manière d'éclairer les lieux. La question la
					plus importante pour nous est de savoir à quoi l'éclairage devrait ressembler dans les décennies à
					venir. Comment la lumière doit-elle contribuer à la sécurité, à l'orientation et à la beauté ?
					Comment pouvons-nous éviter que nos limites écologiques ne soient davantage mises à l'épreuve ?
					Existe-t-il une lumière parfaite ? La nature nous fournit les réponses.
				`,
'sfdc4d81d8340cbd7': `Configuration luminaire`,
'sfe6c68330a2bd563': `Lumière au rythme de la nature pour les personnes, les plantes et les animaux`,
'sff2a34f5dc1a1f44': `Inlay`,
'sffdadf0a576fd802': `Hauteur`,
's85b8f40120ac19bf': `Finalize`,
'sc8da3cc71de63832': `Login`,
's6909fbf252fb79dc': `Please enter your credentials to login.`,
's2759a0a1d167ad8d': `Log in to access.`,
's175d37c8eb04d73e': `Downloads`,
's2937ff34f32d2b26': `Pricelist`,
's6a11b5bd13c5c0bf': `Apps with extended Features`,
'sec57968fd4931f90': `Configurator`,
's8b15707964e87086': `Light Profile`,
'sbec5d3de6f675b65': `load Model Id`,
's4006039e1a7433a1': `load specification id`,
'se5ee9d0c0f004260': `This configuration is based on an older data set. The loaded properties are displayed correctly if possible, but they may by incomplete. Please check and reconfigure if necessary.`,
's9ec2699513c0f9c3': `close`,
's281e280dac2b6d0f': `Basic data`,
's79c731c42cef04ba': `model overview, product and project images`,
's2c6d92528b3eec9b': `basic data sheet, product and project images`,
's79031140b7a4524b': `photometry, revit, assembly instructions`,
's617ddd6d427c8cb3': `detailed data sheet, product and project images`,
's5139cc56230d0317': `tender texts`,
'se25bd8a1ce2fdb60': `Hide Personalisation`,
's0bdb10ecdb3fce26': `Personalise Specsheet`,
'sb543b881adfd8f63': `Start new Configuration`,
's5c61760bb5831e7a': `Review Specsheet and Finalize Configuration`,
'sf9b1c0661a02d9f9': `Configuration`,
's4f4a0a3957f6409b': `Specification ID`,
's63d1951640439972': `Products and Parts`,
'sba98a7152d80b949': `Amount`,
's19e8d4c5ba537449': `Product ID`,
'sa3cfca3e99cec11f': `Download Specsheet`,
's48f220d2f0f98106': `View Specsheet`,
'sdae662c8473f8db8': `Download Tender Text`,
's8270995cf37770f1': `Copy Tender Text`,
'sc42c19e54dee932a': `Share Configuration`,
's8310bd373d383154': `Start a new configuration`,
's21f4cc510ca89b33': `More configurations`,
'scfe3a7e083cd9be6': `Preparing Downloads`,
's8a06a737a64acb51': `Finalize Configuration`,
'sca18d17ab22255c3': `Configuration can not be changed after finalization.`,
's0fb158a2339568d6': `Personalisation`,
's7cb4e55c59663b1c': `Company`,
's87bae2710b2492c3': `Contact`,
'sf1bc83d2509bafcf': `Phone`,
's63e457bc703a3030': `E-Mail`,
's9cd05d781f493167': `Project Name/ID`,
's08bddfaaf372f2f2': `Project Address`,
's6686fcc6d2c8f0bd': `Note`,
'sc82317db41b29853': `Model ID`,
's73d3c06c3590a656': `Eff.`,
'sd1e8bf20abe69b4a': `Self Sufficiency Days`,
's5fcdde07ae1161a8': `All Seasens`,
's8d0c149470d44f94': `summer`,
's387622cbff9d7bdc': `spring/fall`,
'se59367ea12bc61cc': `winter`,
's324d6c1ce4504744': `Self Sufficient Days`,
's600662143fc19adc': `Spring/Fall`,
's79aea3f15705d95d': `Nature-Centric Lighting`,
'sd04d174ea40dfa50': `The steel variant will be discontinued.`,
's94d7caa74edbbffc': `Configure the aluminium variant here.`,
    };
  